import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Student } from 'src/app/model/student.model';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TeacherService } from '../teacher/teacher.service';
import { SafeHtml } from '@angular/platform-browser';
import { HomeService } from '../home/home.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UploadStory } from '../model/upload-story.model';
//import { HttpClient } from '@angular/common/http';
import { StoryAssignedDialogComponent } from './story-assigned-dialog/story-assigned-dialog.component';
import { AssignStory } from '../model/story.model';
import { StorybookAssignmentService } from '../shared/services/storybook.assignment.service';
import { StudentStorybookAssignment } from '../model/student.storybook.assignment.model';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'my-student-list',
  templateUrl: './my-students-list.component.html',
  styleUrls: ['./my-students-list.component.scss'],
})
export class MyStudentListComponent implements OnInit {

  searchedStudentName: string = "All";
  language: string;
  textDir: string;
  private destroy$ = new Subject<void>();

  @Input() status: string;
  allStudentsObjects: Student[] = [];
  currentDisplayStudentObjects: Student[] = [];
  tableReady: boolean = false;
  items = [];
  pageOfItems: Array<any>;
  safeAvatarSVG: SafeHtml;
  isStudentConnected: boolean = false;
  username: string ;
  readingLevel: string;

  displayedColumns: string[] = [
    'myStudents.studentImage',
    'myStudents.studentFullName',
    'findStudents.studentUsername',
    'myStudents.studentReadingLevel',
    //'myStudents.age',
    'myStudents.studentAction'
  ];

  constructor(
      private router: Router,
      private http: HttpClient,
      private translate: TranslateService,
      private teacherService: TeacherService,
      private snackBar: MatSnackBar,
      private homeService: HomeService,
      private dialog: MatDialog,
      private storybookAssignment: StorybookAssignmentService
    ) {
    this.language = translate.currentLang;
    translate.onLangChange.pipe(takeUntil(this.destroy$))
        .subscribe(({ lang }) => {
          this.language = lang
          if (this.language === 'ar'){
            this.textDir = 'rtl';
          }
          else {
            this.textDir = 'ltr';
          }
        });
  }
  
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.fetchAllStudents();
  }

  fetchAllStudents(): void {
    let avatarUser = JSON.parse(localStorage.getItem("avatarUser"));
    this.teacherService.getAllStudentsByStatusAndTeacherId("CONNECTED",avatarUser.teacherId).subscribe((allStudents: Student[]) => {
      //console.log(allStudents);
      if (allStudents.length > 0){
        this.isStudentConnected = true;
        this.safeAvatarSVG = this.homeService.getAvatarImage();
        this.allStudentsObjects = allStudents;
        this.items = this.allStudentsObjects;
        this.filterStudents();
        this.displayTable();
      }
    });
  }

  // f1(strname) {
  //   this.strname = strname;
  //   localStorage.setItem("strname", JSON.stringify(this.strname));
  // }

  filterStudents(): void {
    this.currentDisplayStudentObjects = [];

    //
    for (var i = 0; i < this.allStudentsObjects.length; i++) {

      var currentStudentName = this.allStudentsObjects[i].name;
      var currentStudentUserName = this.allStudentsObjects[i].username;

      if (this.searchedStudentName != "All"){
        if (currentStudentName.trim().toLocaleLowerCase().includes(this.searchedStudentName.trim().toLocaleLowerCase())
                ||
            currentStudentUserName.trim().toLocaleLowerCase().includes(this.searchedStudentName.trim().toLocaleLowerCase())
        ) {
          this.currentDisplayStudentObjects.push(this.allStudentsObjects[i]);
        }
      }else {
        this.currentDisplayStudentObjects.push(this.allStudentsObjects[i]);
      }
      
    }
  }

  displayTable(){
    this.tableReady = true;
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }

  sendAssignStoryRequest(selectedStorybook: AssignStory) {
    //console.log("Selected Story Book: " + selectedStorybook);
    var formData = new FormData()
    formData.append('storybookId', selectedStorybook.storybookId.toString())
    formData.append('username', selectedStorybook.storyUserName);
    this.storybookAssignment.saveNewStorybookAssignment(formData).subscribe((response) => {
      console.log(response);
      this.snackBar.open(response, "", {duration: 1000});
    });
  }

  callAssignStoryBook(username:string,readingLevel:string,studentId:string){
    //console.log(username);
    const dialogRef = this.dialog.open(StoryAssignedDialogComponent, {
      minWidth: '250px',
      width: '60%',
      data: {username: username,readingLevel: readingLevel,studentId:studentId}
    });

    dialogRef.afterClosed().subscribe(data => {
      if (!data) {
        return;
      }
      this.sendAssignStoryRequest(data.selectedStorybook);        
    });
  }

  updateStudentInfo(studentInfo: Student){
    this.teacherService.updateStudentInfo(studentInfo)
    .subscribe((response: Student)=> {
      //localStorage.setItem("user", JSON.stringify(response))
      this.snackBar.open("Request Sent to Student", "", {duration: 2000});
      this.fetchAllStudents();
    }); 
  }

  applyFilter() {
    this.filterStudents();
    this.pageOfItems = this.currentDisplayStudentObjects;
  }
}
